import $ from 'jquery';
import React, { useLayoutEffect, useState } from 'react';
import throttle from 'lodash/throttle';
import { KEYCODE } from '../../tettra-editor/utilities/CONSTANTS';
import { updateWindowDraftTitle } from '../../utilities/documentTitleUtilities';

const DraftTitle = ({ title, setTitle, isTemplateDraft }) => {
    const textInput = React.createRef();

    const resizeObserver = new ResizeObserver(throttle((entries) => {
        setHeight();
    }, 1200));

    useLayoutEffect(() => {
        setTimeout(() => setHeight(), 0);
        textInput.current.focus();
        resizeObserver.observe(document.getElementById('post-editor-title'));

        return () => (resizeObserver.disconnect());
    }, []);

    const setHeight = () => {
        if (!textInput.current) return;
        textInput.current.style.height = '47px';
        const { scrollHeight } = textInput.current;
        textInput.current.style.height = `${scrollHeight}px`;
    };

    const onChange = ({ target }) => {
        const { value: draftTitle, scrollHeight } = target;
        setTitle(draftTitle);
        setHeight();
    };

    const onKeyDown = (e) => {
        const { keyCode } = e;
        if (keyCode == KEYCODE.enter) {
            e.preventDefault();
            $('#enter-trigger').first().click();
        }
    };

    window._tettraDraft.title = title;
    updateWindowDraftTitle(title);

    return (
        <textarea
            ref={textInput}
            id="post-editor-title"
            className="post-editor-title"
            placeholder={`${isTemplateDraft ? 'Template' : 'Page'} Title`}
            name="title"
            cols="50"
            rows="50"
            maxLength="191"
            onChange={onChange}
            onKeyDown={onKeyDown}
            value={title || ''}
        />
    );
};

export default DraftTitle;
